import { useEffect, useRef } from 'react'
import axios from 'axios'

import { useAppSelector } from '#/app/store/store'
import { getModalById, LOW_BALANCE_OFFER } from '#/features/modals'
import { LowBalanceOfferPlate } from './low-balance-offer-plate'
import type { ResponseAllInfo } from '#/entities/user-account/model/user-type-slice'
import { isEnvFlagEnabled } from '#/shared/lib/constants/constants'
import { balanceSelector } from '#/shared/lib/selectors'

export const LowBalanceOfferTrigger = () => {
	const balance = useAppSelector(balanceSelector)
	const me = useAppSelector((state) => state.user) as ResponseAllInfo & { status: string; referral: string }
	const isFewTokensModalEnabled = isEnvFlagEnabled(process.env.NEXT_CLIENT_FEW_TOKENS_MODAL_ENABLED)
	const prevBalanceRef = useRef<number | null>(null)
	const modal = getModalById(LOW_BALANCE_OFFER)

	useEffect(() => {
		const interceptorId = axios.interceptors.response.use(
			(response) => {
				if (response.status === 402 && response?.data?.detail?.includes('Баланс')) {
					invokeLowBalanceOffer(true)
				}
				return response
			},
		)

		return () => {
			axios.interceptors.response.eject(interceptorId)
		}
	}, [])

	useEffect(() => {
		if (!isFewTokensModalEnabled) return

		// Пропускаем первый рендер (начальная загрузка баланса)
		if (prevBalanceRef.current === null) {
			prevBalanceRef.current = balance
			return
		}

		if (prevBalanceRef.current !== balance) {
			prevBalanceRef.current = balance

			if (typeof window !== 'undefined' && sessionStorage.getItem('low-balance-offer-shown') === 'true') {
				return
			}

			invokeLowBalanceOffer()
		}
	}, [balance, me, modal, isFewTokensModalEnabled])

	const invokeLowBalanceOffer = (notEnoughtTokens: boolean = false) => {
		const tokensPerPlan = Number(me.payment_plan?.plan?.tokens_per_plan)
		const isCorporate = me.payment_plan?.plan?.is_corporate
		const isFreePlan = tokensPerPlan <= 10
		const threshold = tokensPerPlan * 0.15
		const freePlanThreshold = tokensPerPlan * 0.3

		if (isCorporate) {
			return
		}

		if (!isFreePlan && balance < threshold) {
			modal.setState(true, { offerUid: me.payment_plan?.plan?.uid, me, notEnoughtTokens })
			sessionStorage.setItem('low-balance-offer-shown', 'true')
			return
		}

		if (isFreePlan && balance < freePlanThreshold) {
			modal.setState(true, { offerIndex: 1, notEnoughtTokens })
			sessionStorage.setItem('low-balance-offer-shown', 'true')
			return
		}
	}

	return <LowBalanceOfferPlate />
}
